import React from "react";
import type { SingleCardProps } from "../../types";
import LocaleSelectBox from "../locale-select-box/LocaleSelectBox";
import { ThemeSwitcher } from "../theme-switcher/ThemeSwitcher";
import "./CardAuth.scss";

export const CardAuth = ({
  title,
  description,
  children,
}: React.PropsWithChildren<SingleCardProps>) => {
  return (
    <div className="auth-card">
      <div className="dx-card content">
        <div className="header">
          <div className="title">{title}</div>
          {description ? (
            <div className="description">{description}</div>
          ) : null}
        </div>
        {children}
        <hr className="auth-card-separator" />
        <div className="auth-card-footer">
          <LocaleSelectBox />
          <ThemeSwitcher />
        </div>
      </div>
    </div>
  );
};
